"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Promo;
const react_1 = __importDefault(require("react"));
const raw_html_1 = __importDefault(require("~/components/jsx-helpers/raw-html"));
function Promo({ promoteSnippet }) {
    // promoteSnippet may or may not be in an array
    const data = promoteSnippet instanceof Array ? promoteSnippet[0] : promoteSnippet;
    if (!(data === null || data === void 0 ? void 0 : data.content)) {
        return null;
    }
    return (react_1.default.createElement(raw_html_1.default, { html: data.content.description }));
}
